import { render, staticRenderFns } from "./GBoothCard.vue?vue&type=template&id=c687c0a0&scoped=true&"
import script from "./GBoothCard.vue?vue&type=script&lang=ts&"
export * from "./GBoothCard.vue?vue&type=script&lang=ts&"
import style0 from "./GBoothCard.vue?vue&type=style&index=0&id=c687c0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c687c0a0",
  null
  
)

export default component.exports